import {useEffect, useState} from 'react'
import {useBreakpointValue} from '@salesforce/retail-react-app/app/components/shared/ui'

const QUICK_ADD_MIN_WIDTH = 230

const getModeFromWidth = (width) => (width >= QUICK_ADD_MIN_WIDTH ? 'quick-add' : 'quick-view')

const useProductTileMode = ({tileRef, productId}) => {
    const [tileWidth, setTileWidth] = useState(null)
    const [isTouch, setIsTouch] = useState(false)
    const [tileMode, setTileMode] = useState(null)
    const isDesktop = useBreakpointValue({base: false, lg: true})

    useEffect(() => {
        if (typeof window === 'undefined') {
            return undefined
        }

        const mediaQuery = window.matchMedia?.('(pointer: coarse)')
        const updateTouch = () => {
            const hasTouchPoints =
                navigator?.maxTouchPoints > 0 || navigator?.msMaxTouchPoints > 0
            const coarsePointer = mediaQuery?.matches === true
            setIsTouch(Boolean(hasTouchPoints || coarsePointer))
        }

        updateTouch()

        if (mediaQuery?.addEventListener) {
            mediaQuery.addEventListener('change', updateTouch)
            return () => mediaQuery.removeEventListener('change', updateTouch)
        }
        if (mediaQuery?.addListener) {
            mediaQuery.addListener(updateTouch)
            return () => mediaQuery.removeListener(updateTouch)
        }

        return undefined
    }, [])

    useEffect(() => {
        const node = tileRef?.current
        if (!node || typeof window === 'undefined') {
            return undefined
        }

        const updateWidth = () => {
            const width = node.getBoundingClientRect?.().width
            if (typeof width === 'number' && !Number.isNaN(width)) {
                setTileWidth(width)
            }
        }

        updateWidth()

        if (typeof ResizeObserver === 'undefined') {
            window.addEventListener('resize', updateWidth)
            return () => window.removeEventListener('resize', updateWidth)
        }

        const observer = new ResizeObserver((entries) => {
            const entry = entries[0]
            const width = entry?.contentRect?.width
            if (typeof width === 'number' && !Number.isNaN(width)) {
                setTileWidth(width)
            }
        })

        observer.observe(node)
        return () => observer.disconnect()
    }, [tileRef])

    useEffect(() => {
        if (!isDesktop || isTouch) {
            setTileMode('quick-view')
            return
        }
        if (typeof tileWidth !== 'number') {
            return
        }
        setTileMode(getModeFromWidth(tileWidth))
    }, [tileWidth, isTouch, isDesktop])

    useEffect(() => {
        if (!productId || !tileMode) {
            return
        }
    }, [])

    return {tileMode, tileWidth, isTouch}
}

export default useProductTileMode
